import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import SmallTitle from './smallTitle/';
import Classify from './classify/';

class PerIntroWithAnchor extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content, title, id, rank } = this.props;

        const anchors = [`#${id}AF`, `#${id}GL`, `#${id}MT`, `#${id}UZ`];

        return (
            <div className={styles.peopleList}>
                <SmallTitle title={title} anchors={rank ? anchors : []} rank={rank} />
                <Classify rank={rank} content={content} id={id} />
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
PerIntroWithAnchor.propTypes = {
    content: PropTypes.array,
    title: PropTypes.string,
    id: PropTypes.string,
    rank: PropTypes.bool,
};

/**
 * 定义组件默认属性
 * */
PerIntroWithAnchor.defaultProps = {};

export default PerIntroWithAnchor;
